module.exports = __webpack_public_path__ + "img/5.1014e381.png";